import { useEffect } from 'react';

interface IUseDisableRightClickParams {
  element?: HTMLElement | null;
  disabled?: boolean;
}

export const useDisableRightClick = ({ element, disabled = false }: IUseDisableRightClickParams = {}) => {
  useEffect(() => {
    const handleContextMenu = (e: Event) => {
      e.preventDefault();
    };

    if (!element || disabled) {
      return;
    }

    element.addEventListener('contextmenu', handleContextMenu);

    return () => {
      element.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [element, disabled]);
};
